import { render, staticRenderFns } from "./PlaceTraining.vue?vue&type=template&id=10065360&scoped=true"
import script from "./PlaceTraining.vue?vue&type=script&lang=js"
export * from "./PlaceTraining.vue?vue&type=script&lang=js"
import style0 from "./PlaceTraining.vue?vue&type=style&index=0&id=10065360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10065360",
  null
  
)

export default component.exports